"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const paths_1 = require("@/common/app/paths");
exports.default = (0, vue_1.defineComponent)({
    name: 'admin-home',
    data() {
        return {
            paths: [
                paths_1.paths.API_STATS,
                paths_1.paths.GAMES_OVERVIEW,
                paths_1.paths.API_GAMES,
                paths_1.paths.API_METRICS,
                paths_1.paths.LOAD,
                paths_1.paths.API_IPS,
            ],
        };
    },
    computed: {
        serverId() {
            return new URLSearchParams(window.location.search).get('serverId') || '';
        },
    },
});
